import { readable } from "svelte/store";
import debounce from "lodash.debounce";

const DEBOUNCE_DURATION = 250;

export default readable({ width: 0, height: 0 }, (set) => {
	const onResize = () => set({ width: window.innerWidth, height: window.innerHeight });

	// Run once on mount, and then anytime the window is resized
	onResize();
	window.addEventListener('resize', debounce(onResize, DEBOUNCE_DURATION));

	// Cleanup function
	return () => { window.removeEventListener('resize', onResize); };
});